import type { MarketplaceSolanaChain } from "@/app/blockchains/required-client-blockchains"

// The Solana dApp Store app is a WebView shell around the site; it appends
// this to the user agent.
const SOLANA_MOBILE_WEB_SHELL_USER_AGENT = "Solana Mobile Web Shell"

let isRegistered = false

export function isSolanaMobileWebShell() {
  return (
    typeof navigator !== "undefined" &&
    navigator.userAgent.includes(SOLANA_MOBILE_WEB_SHELL_USER_AGENT)
  )
}

export function isAndroid() {
  return (
    typeof navigator !== "undefined" && /android/i.test(navigator.userAgent)
  )
}

/**
 * Registers Mobile Wallet Adapter as a wallet-standard wallet, which Privy
 * lists as "Mobile Wallet Adapter". It opens the phone's wallet app (Seed
 * Vault, Phantom, Solflare) on Android, in Chrome and in the dApp Store shell.
 * registerMwa only logs a warning elsewhere, so skip it off Android and keep
 * the package out of the main bundle.
 */
export function registerSolanaMobileWallet(chain: MarketplaceSolanaChain) {
  if (isRegistered || !isAndroid()) return
  isRegistered = true

  import("@solana-mobile/wallet-standard-mobile")
    .then(
      ({
        createDefaultAuthorizationCache,
        createDefaultChainSelector,
        createDefaultWalletNotFoundHandler,
        registerMwa,
      }) => {
        registerMwa({
          appIdentity: {
            name: "Rarible",
            uri: window.location.origin,
            icon: "icons/icon-192.png",
          },
          authorizationCache: createDefaultAuthorizationCache(),
          chains: [chain],
          chainSelector: createDefaultChainSelector(),
          onWalletNotFound: createDefaultWalletNotFoundHandler(),
        })
      },
    )
    .catch((error) => {
      isRegistered = false
      console.error("[MWA] Failed to register Mobile Wallet Adapter:", error)
    })
}
